import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "h-100" }
const _hoisted_2 = { class: "flex overflow-hidden md:m-4 bg-white md:rounded shadow" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "hidden md:block py-4 px-6 font-bold text-gray-900 bg-gray-200" }, " Search ", -1)
const _hoisted_4 = { class: "flex-grow py-2 px-3" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "flex relative items-center px-1 md:px-3 h-full bg-gray-200" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("button", {
  class: "px-1 md:px-4 font-bold text-white bg-green-400 hover:bg-green-500",
  type: "submit"
}, " Search ", -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "p-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_select = _resolveComponent("n-select")!
  const _component_scene_card = _resolveComponent("scene-card")!
  const _component_b_pop_transition = _resolveComponent("b-pop-transition")!
  const _component_b_pagination = _resolveComponent("b-pagination")!
  const _component_b_overlay = _resolveComponent("b-overlay")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_b_overlay, {
      loading: _ctx.$apollo.loading
    }, {
      default: _withCtx(() => [
        _createElementVNode("form", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.query) = $event)),
              disabled: "",
              type: "text",
              name: "query",
              placeholder: "Search...",
              class: "p-2 m-0 w-full bg-transparent border-transparent focus:border-gray-200 focus:ring-gray-100"
            }, null, 512), [
              [_vModelText, _ctx.query]
            ])
          ]),
          (!_ctx.query)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_n_select, {
                    value: _ctx.sortBy,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.sortBy) = $event)),
                    options: _ctx.orderOptions,
                    "menu-props": {class: 'border-transparent bg-transparent focus:ring-transparent focus:border-transparent focus:bg-transparent text-gray-500 sm:text-sm'}
                  }, null, 8, ["value", "options"])
                ])
              ]))
            : _createCommentVNode("", true),
          _hoisted_7
        ]),
        (_ctx.scenes)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_component_b_pop_transition, { class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-5 p-4" }, {
                default: _withCtx(() => [
                  (!_ctx.scenes.collection.length)
                    ? (_openBlock(), _createElementBlock("h1", _hoisted_9, " No scenes found "))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scenes.collection, (scene) => {
                    return (_openBlock(), _createBlock(_component_scene_card, {
                      key: `scene-${scene.id}`,
                      scene: scene
                    }, null, 8, ["scene"]))
                  }), 128))
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_b_pagination, {
            meta: _ctx.paginationMeta,
            onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onPaginate($event)))
          }, null, 8, ["meta"])
        ])
      ]),
      _: 1
    }, 8, ["loading"])
  ]))
}